import JobDescriptions from "./JobDescriptions";

export default JobDescriptions;
